module.exports = __webpack_public_path__ + "static/bg-cast-header-991-38f8ba248d7111f2e6e168e533af4a6b.jpg";